import { render, staticRenderFns } from "./hotStandby.vue?vue&type=template&id=cac5e070&scoped=true&"
import script from "./hotStandby.vue?vue&type=script&lang=js&"
export * from "./hotStandby.vue?vue&type=script&lang=js&"
import style0 from "./hotStandby.vue?vue&type=style&index=0&id=cac5e070&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac5e070",
  null
  
)

export default component.exports